import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ArrowCircleRight = () => <FontAwesomeIcon icon={['far', 'arrow-alt-circle-right']}/>;
export const ArrowCircleDown = () => <FontAwesomeIcon icon={['far', 'arrow-alt-circle-down']}/>;
export const TimesCircle2X = () => <FontAwesomeIcon icon={['far', 'times-circle']} size="2x"/>;
export const Compass5X = () => <FontAwesomeIcon icon={['far', 'compass']} size="5x"/>;
export const FileIcon = () => <FontAwesomeIcon icon={['far', 'file-alt']} />
export const NewspaperIcon = () => <FontAwesomeIcon icon={['far', 'newspaper']} />
export const CalendarIcon = () => <FontAwesomeIcon icon={['far', 'calendar-alt']} />
